import { Environment } from 'config';
import NavigationConfig from 'navigation/config';
import React from 'react';
import { Link } from 'react-router-dom';
import * as HostSelectors from 'redux/reducers/gl_host_provider/selectors';
import { requiredLogin } from '../../../../middlewares';
import useStyles from '../styles';

const Logo = () => {
  const classes = useStyles({});
  const logo = HostSelectors.useHostLogo();
  return (
    <Link style={{}} to={NavigationConfig.homePage().path}>
      <img
        alt="logo"
        src={logo || ''}
        onError={(e: any) => {
          e.target.src = `${Environment.API_BASE_URL}/storage/default.jpg`;
        }}
        style={{
          height: 50,
          boxShadow: '0 0 15px rgb(0 ,0 ,0 ,0.2)',
          borderRadius: 5,
        }}
      />
    </Link>
  );
};

export default Logo;
